import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import _, { findIndex as _findIndex, forEach as _forEach, sortBy } from 'lodash';

import { categoryOptionFromEntity } from 'components/forms/autocomplete/Category';

import EntityPropsUpdater from 'component/EntityPropsUpdater';
import Entity from 'components/Entity';
import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';

import FormSwitchery from 'components/forms/FormSwitchery';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';
import FormLangRichEditor from 'components/forms/FormLangRichEditor';

import CmsCanvas from 'components/cms/CmsCanvas';

import { entityMetaMapping } from 'js/constants';
import Axios from 'axios';
import ReactTooltip from 'react-tooltip';
import Modal from '../../Modal';
import FormLangInput from "components/forms/FormLangInput";
import Loader from "components/layout/Loader";
import {getCategoriesSettingsR} from "actions/TemplateSettingsActions";
import {getNameInCurrentLanguage} from "helpers/intl";
import FormTextarea from 'components/forms/FormTextarea';

class ItemData extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      showVendorApi: false,
      vendorApiResult: null,
      receivingData: false,
    };
  }

  componentDidMount = () => {
    if(this.props.categoriesSettings?.list === undefined ||
      this.props.listCategories?.data?.list?.length > 0 &&
      (_.isEqual(this.props.categoriesSettings?.list, this.props.listCategories?.data?.list) === false)){
      this.props.getCategoriesSettingsR();
    }
  }

  // make sure there is a CMS description for given language
  getCmsDescriptionEntity = () => {
    const { entity, appIntl } = this.props;

    const descriptionIndex = _findIndex(entity.getCmsDescription(), ['language', appIntl.displayIntlForm]);
    if (descriptionIndex > -1) {
      return this.getEntityForCms(entity.getCmsDescription()[descriptionIndex]);
    }

    // create new value and return it
    const newValue = entity.getCmsDescription().slice();
    const newDescription = entity.createValue('cmsDescription', [], { language: appIntl.displayIntlForm });
    newValue.push(newDescription);

    this.updateEntity('cmsDescription', newValue);

    return this.getEntityForCms(newDescription);
  };

  getEntityForCms = data => {
    const entity = new Entity();
    entity.setData(data);
    entity.setMeta(this.props.meta, entityMetaMapping.cmsDescription);

    return entity;
  };

  updateDescriptionType = (e, descriptionType) => {
    e.preventDefault();
    e.stopPropagation();

    this.updateEntity('descriptionType', descriptionType);
  };

  updateCmsDescription = content => {
    const { entity, appIntl } = this.props;
    const descriptionIndex = _findIndex(entity.getCmsDescription(), ['language', appIntl.displayIntlForm]);
    this.updateEntity('content', content, ['cmsDescription', descriptionIndex.toString()]);
  };

  getVendorId = e => {
    const { entity, appIntl } = this.props;
    const { vendorApiResult } = this.state;
    if (vendorApiResult !== null) {
      this.setState({
        showVendorApi: true,
      });
      return;
    }

    this.setState({
      receivingData: true,
    });

    const vendorClientId = entity.getVendor() === null ? null : entity.getVendor().getUsername();

    Axios.get('/api/vendorproductlists/' + vendorClientId + '.json', {})
      .then(response => {
        const groups = [];

        _forEach(response.data, (group, index) => {
          groups.push({
            description: group.description,
            id: group.product_group_id,
            name: group.name,
          });
        });

        this.setState({
          showVendorApi: true,
          receivingData: false,
          vendorApiResult: sortBy(groups, ['name']),
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  setVendorItemId = e => {
    this.updateEntity('vendorId', e.target.getAttribute('data-id'), ['ident']);
    this.updateEntity('vendorName', e.target.getAttribute('data-name'), ['ident']);
    this.vendorItemId.setValue(e.target.getAttribute('data-id'));
    this.vendorItemName.setValue(e.target.getAttribute('data-name'));
    this.setState({
      showVendorApi: false,
    });
  };

  getCategoryPath = (item) => {
    const { appIntl, categoriesSettings } = this.props;
    let categoryName = "";
    if(typeof item.category_path !== undefined && typeof item.category_path === 'string'){
      let path = item.category_path.split(",");
      let cleanedPath = [];
      _forEach(path, (singlePath, i) => {
        if (singlePath !== "" && singlePath !== "0") {
          cleanedPath.push(singlePath);
        }
      });
      _forEach(cleanedPath, (singleCleanedPath, i) => {
        if(cleanedPath.length-1 > i){
          const index = _.findIndex(categoriesSettings?.list, category => category.id === singleCleanedPath);
          if (index !== -1) {
            categoryName = categoryName + getNameInCurrentLanguage(categoriesSettings?.list[index].name, appIntl) + " > "
          }
        }
      });
    }
    return categoryName;
  }

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
      owner,
      updateOwner,
      printItem,
    } = this.props;
    const { showVendorApi, receivingData, vendorApiResult } = this.state;
    return (
      <div class="clearfix">
        {vendorApiResult !== null && (
          <Modal
            show={showVendorApi}
            onHide={() => {
              this.setState({ showVendorApi: false });
            }}
            bsSize="lg"
          >
            <ReactTooltip id="top" place="top" effect="solid" />
            <Modal.Header closeButton>
              <Modal.Title>{messages.select_vendor_product}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {vendorApiResult.map((variant, i) => {
                return (
                  <p
                    className="p_selector"
                    data-tip={variant.description}
                    data-for="top"
                    onClick={this.setVendorItemId}
                    data-id={variant.id}
                    data-name={variant.name}
                  >
                    {variant.name}
                  </p>
                );
              })}
            </Modal.Body>
          </Modal>
        )}
        {entityLoaded && (
          <div>
            <Row>
              <Col xs={12} md={inModal ? 12 : 6}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <p>{messages.item}</p>
                    <div class="form-group-attached">
                      {this.props.pendingCategoriesSettings ? <Loader/> :
                        <FormAutocomplete
                        label={messages.category + " " + this.getCategoryPath(entity?.data)}
                        name="category"
                        value={categoryOptionFromEntity(entity.getCategory())}
                        meta={entity.getCategoryMetaInformation()}
                        validation={entity.getCategoryValidationResult()}
                        onChange={(name, value) => {
                        this.updateEntityMultiple([name, 'categoryPath'], [value, value.path]);
                      }}
                        returnValueObject
                        autocompleteType="category"
                        complete
                        disabled={disabled}
                        />
                      }
                      {typeof entity.getName() === 'object' ?
                      <FormLangInput
                        label={messages.name}
                        name="name"
                        value={entity.getName()}
                        meta={entity.getNameMetaInformation()}
                        validation={entity.getNameValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />  :
                      <FormInput
                        label={messages.name}
                        name="name"
                        value={entity.getName()}
                        meta={entity.getNameMetaInformation()}
                        validation={entity.getNameValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      }
                      <FormAutocomplete
                        label={messages.item_type}
                        name="type"
                        value={entity.getType()}
                        meta={entity.getTypeMetaInformation()}
                        validation={entity.getTypeValidationResult()}
                        onChange={this.updateEntity}
                        options={[
                          { value: 'itemPrint', label: messages.print_item },
                          { value: 'itemWebsite', label: messages.website_item },
                          { value: 'item', label: messages.normal_item },
                        ]}
                        disabled={disabled}
                      />
                      <FormTextarea
                        label={messages.internal_comment}
                        name="internalComment"
                        value={entity.getInternalComment()}
                        meta={entity.getInternalCommentMetaInformation()}
                        validation={entity.getInternalCommentValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled} />
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={inModal ? 12 : 6}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <p>{messages.identification}</p>
                    <div class="form-group-attached">
                      <FormAutocomplete
                        label="Vendor"
                        name="vendor"
                        value={entity.getVendor()}
                        onChange={this.updateEntity}
                        autocompleteType="vendor"
                        disabled={disabled}
                        returnValueObject
                        /*
                       options={options2.map(option => {
                          return { label: option, value: option };
                        })}

                         */
                      />
                      <FormInput
                        label={messages.cc_item_id}
                        name="sku"
                        value={entity.getIdent().getSku()}
                        meta={entity.getIdent().getSkuMetaInformation()}
                        validation={entity.getIdent().getSkuValidationResult()}
                        onChange={(name, value) => this.updateEntity(name, value, ['ident'])}
                        disabled={disabled}
                      />
                    </div>
                    <div className="form-group-attached form-inline itemDataFormGroup">
                      <FormInput
                        label={messages.vendor_item_id}
                        name="vendorId"
                        ref={ref => (this.vendorItemId = ref)}
                        value={entity.getIdent().getVendorId()}
                        meta={entity.getIdent().getVendorIdMetaInformation()}
                        validation={entity.getIdent().getVendorIdValidationResult()}
                        onChange={(name, value) => this.updateEntity(name, value, ['ident'])}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.vendor_item_name}
                        name="vendorName"
                        ref={ref => (this.vendorItemName = ref)}
                        value={entity.getIdent().getVendorName()}
                        meta={entity.getIdent().getVendorNameMetaInformation()}
                        validation={entity.getIdent().getVendorNameValidationResult()}
                        onChange={(name, value) => this.updateEntity(name, value, ['ident'])}
                        disabled
                      />{' '}
                      {printItem && (
                        <Button disabled={receivingData} bsStyle="danger" onClick={this.getVendorId}>
                          <i
                            className={
                              'fa-fw ' + (receivingData ? ' fa fa-circle-notch fa-spin' : 'fas fa-cloud-download')
                            }
                          />
                          {' ' + messages.get_vendor_id}
                        </Button>
                      )}
                    </div>
                    <div className="form-group-attached">
                      <FormInput
                        label={messages.internal_item_id}
                        name="internal"
                        value={entity.getIdent().getInternal()}
                        meta={entity.getIdent().getInternalMetaInformation()}
                        validation={entity.getIdent().getInternalValidationResult()}
                        onChange={(name, value) => this.updateEntity(name, value, ['ident'])}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.upc}
                        name="upc"
                        value={entity.getIdent().getUpc()}
                        meta={entity.getIdent().getUpcMetaInformation()}
                        validation={entity.getIdent().getUpcValidationResult()}
                        onChange={(name, value) => this.updateEntity(name, value, ['ident'])}
                        disabled={disabled}
                      />
                    </div>
                    <p class="m-t-10">{messages.visibility}</p>
                    <div>
                      <FormSwitchery
                        name="isActive"
                        checked={entity.getIsActive()}
                        value
                        label={messages.show_item_online}
                        onChange={this.updateEntity}
                      />
                    </div>
                    <p className="m-t-10">{messages.editor_settings}</p>
                    <div>
                      <FormSwitchery
                        name="hidePreview"
                        checked={entity.getHidePreview()}
                        value
                        label={messages.hide_preview}
                        onChange={this.updateEntity}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    {entity.getDescriptionType() === 'cms' ? (
                      <a href="#useText" onClick={e => this.updateDescriptionType(e, 'text')}>
                        {messages.use_text_description}
                      </a>
                    ) : (
                      <a href="#useCms" onClick={e => this.updateDescriptionType(e, 'cms')}>
                        {messages.use_visual_builder}
                      </a>
                    )}

                    {entity.getDescriptionType() === 'cms' ? (
                      <div>
                        <div class="p-t-15 p-b-15">
                          <IntlFormInlineSelector /> {messages.description}
                        </div>
                        <CmsCanvas
                          editMode
                          entity={this.getCmsDescriptionEntity()}
                          changeEntity={cmsDescriptionEntity => {
                            this.updateCmsDescription(cmsDescriptionEntity.processedData.content);
                          }}
                          itemId={entity.getId()}
                        />
                      </div>
                    ) : (
                      <div class="form-group-attached">
                        <FormLangRichEditor
                          label={messages.description}
                          name="description"
                          value={entity.getDescription()}
                          meta={entity.getDescriptionMetaInformation()}
                          validation={entity.getDescriptionValidationResult()}
                          onChange={this.updateEntity}
                          disabled={disabled}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}
ItemData.defaultProps = {
  inModal: false,
};

const mapDispatchToProps = dispatch => {
  return {
    getCategoriesSettingsR: () => {
      dispatch(getCategoriesSettingsR());
    },
  };
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    meta: state.entityMeta,
    categoriesSettings: state.templateSettings.categoriesSettings,
    pendingCategoriesSettings: state.templateSettings.pendingCategoriesSettings,
    listCategories: state.list.categories,
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ItemData));
